import type { SurfaceCopy } from './surfaceTypes'

export const surfaceUk: SurfaceCopy = {
  pages: {
    continueLearning: 'Продовжити навчання',
    keepLearning: 'Вчися далі',
    practice: 'Практика',
    practiceSubtitle: 'Разові історії та вправи — текст, який залишиться в бібліотеці, створи в Читанні.',
    settings: 'Налаштування',
    settingsSubtitle: 'Акаунт і вподобання',
  },
  actions: {
    startReading: 'Почати читання',
    browseReading: 'Знайти що почитати',
    startRefresh: 'Почати повторення',
    addWords: 'Додати слова',
    startPractice: 'Почати практику',
    cancel: 'Скасувати',
    saved: 'Збережено',
    readyToRefresh: 'Готово до повторення: {count} слів',
    readyToRefreshOne: 'Готово до повторення: 1 слово',
  },
  coach: {
    title: 'Нотатка від коуча',
    dismiss: 'Сховати',
    andWord: 'і',
    confusionCluster:
      'Ти часто плутаєш {words}. Коротка перевірка допоможе їх розділити.',
    formGap:
      'Ти зустрічав «{surface}» {count} разів під час читання. У {lemma} є форми, яких ти ще не бачив{formsHint}.',
    formGapNoLemma:
      'Ти зустрічав «{surface}» {count} разів під час читання. У базового слова є форми, яких ти ще не бачив{formsHint}.',
    synonymMixup:
      '«{word1}» і «{word2}» схожі за значенням — потренуймося їх розрізняти.',
    synonymMixupGeneric:
      'Ці схожі слова варто розібрати — допоможе коротка перевірка.',
    neglectedWord:
      '{word} не було у фокусі вже {days} дн. Готовий до короткого повторення?',
    neglectedWordGeneric:
      'Це слово не було у фокусі вже {days} дн. Готовий до короткого повторення?',
    ctaPractice: 'Створити статтю з цих слів',
    ctaOpenWord: 'Відкрити слово',
    ctaChallenge: 'Пройти коротку перевірку',
  },
  todayPlan: {
    heading: 'Твій день',
    refresh: 'Повторення',
    newWords: 'Нові слова',
    reading: 'Читання',
    practice: 'AI-практика',
    allCaughtUp: 'На зараз усе повторено',
  },
  dashboard: {
    loadFailed: 'Не вдалося завантажити Today',
    continueLearningEyebrow: 'Продовжити навчання',
    sessionLabelToday: 'Сьогоднішня сесія',
    sessionLabelComplete: 'Сесію на сьогодні завершено',
    headlineResume: 'Продовж з того місця, де зупинився',
    headlineReadyMore: 'Готовий до ще одного раунду?',
    headlineWordsReady: 'Готово до повторення: {count} слів',
    headlineWordsReadyOne: 'Готово до повторення: 1 слово',
    headlineMinutesSession: 'Сесія ~{minutes} хв',
    detailWaiting: 'Твоя сесія чекає на тебе.',
    detailDailyDone: 'Денний мінімум виконано — можна вільно досліджувати.',
    detailWhatNext: 'Що хочеш зробити далі?',
    detailAboutMinutes: 'Близько {minutes} хв у твоєму плані на сьогодні.',
    detailCaughtUp: 'Ти в курсі — далі може бути коротке читання.',
    guidedSessionMinutes: 'Сесія ~{minutes} хв',
    startFailed: 'Не вдалося почати сесію. Спробуй ще раз.',
    wordsThisMonth: '+{count} слів цього місяця',
    totalInVocabulary: '{count} загалом у словнику',
    wordsRefreshedToday: 'Сьогодні повторено: {count} слів',
    wordsRefreshedTodayOne: 'Сьогодні повторено: 1 слово',
    keepMomentum: 'Не втрачай темп',
    yesterdayMissed: 'Вчора пропустив «{word}» — сьогодні {correct} правильно',
    vocabHeading: 'Словник',
    statusNew: 'Нові',
    statusLearning: 'Вивчаю',
    statusReview: 'Повтор',
    statusMastered: 'Опановано',
    dueForReview: 'До повторення',
    viewAllWords: 'Усі слова',
    streak: 'Серія',
    dayInARow: 'день поспіль',
    daysInARow: 'днів поспіль',
    studiedToday: '✓ Ти вчився сьогодні — так тримати!',
    keepStreakAlive: 'Позаймись сьогодні, щоб зберегти серію.',
    startStreak: 'Почни займатись, щоб зібрати серію.',
    latestWin: 'Недавня перемога',
    catalogExploreHint: '— заглянь у базу мови, коли захочеш побродити',
    feedbackCta: 'Ідея чи баг? Напиши нам',
  },
  achievementTitles: {
    FIRST_SESSION: 'Перші кроки',
    WEEK_STREAK: 'Тижневий воїн',
    WORDS_50: 'Колекціонер слів',
    WORDS_100: 'Зростаючий лексикон',
    WORDS_250: 'Будівник словника',
    WORDS_500: 'Сховище слів',
    READING_STREAK_5: 'Ритм читання',
    COMEBACK: 'З поверненням',
    FIRST_MASTERED: 'Перше опанування',
    CHALLENGE_PERFECT: 'Майстер челенджу',
  },
  aiCredits: {
    heading: 'Денні AI-кредити',
    short: 'AI сьогодні',
    ofLimit: '{used} використано · ліміт {limit}',
    compact: 'Залишилось {remaining} з {limit} AI-кредитів на сьогодні',
    hint: 'На генерацію статей, практику та питання за текстом. Пояснення слів із кешу безкоштовні.',
    costPractice: 'Історія або урок: {cost}',
    costArticle: 'Особиста стаття: {cost}',
    costComprehension: 'Питання за прочитаним: {cost}',
    costComprehensionCheck: 'Відгук коуча на відповідь: {cost}',
    reset: 'Скидання о {time} (UTC). Зміна часового поясу не скидає кредити.',
    exceeded: 'Денні AI-кредити закінчились. Скидання опівночі UTC.',
    phraseLimitExceeded: 'Денний ліміт пояснень фраз вичерпано. Вже пояснені фрази працюють — спробуй завтра.',
    phraseQuotaCompact: 'Залишилось {remaining} з {limit} нових пояснень фраз на сьогодні',
  },
  reading: {
    pickedForYou: 'Для тебе',
    tabForYou: 'Для тебе',
    tabLibrary: 'Бібліотека',
    noRecommendationTitle: 'Поки немає рекомендації',
    noRecommendationHint: 'Відкрий бібліотеку або згенеруй статтю зі своїх слів.',
    filterAll: 'Усі',
    filterUnread: 'Непрочитані',
    filterRead: 'Прочитані',
    generatePersonalizedTitle: 'Стаття з твого словника',
    generatePersonalizedHint:
      'AI збере до {max} одиниць із твого словника в короткий особистий текст.',
    generatePersonalizedPrivate: 'Статтю бачиш лише ти — іншим вона не показується.',
    generatePersonalizedWordCount: '{count} з твого словника',
    generatePersonalizedWordCountMax: 'До {max} з твого словника',
    shuffleWords: 'Перемішати',
    generatePersonalizedNoWords: 'Зберігай слова під час читання, щоб відкрити особисті статті.',
    generatePersonalizedCta: 'Згенерувати статтю зі словника',
    generatePersonalizedLoading: 'Пишемо твою статтю…',
    generatePersonalizedFailed: 'Не вдалося згенерувати статтю. Спробуй ще раз.',
    generatePersonalizedFieldLevel: 'Рівень',
    generatePersonalizedFieldDuration: 'Час читання',
    generatePersonalizedFieldTopics: 'Теми',
    generatePersonalizedTopicsHint:
      'Обери до 2 тем. Залиш порожнім — візьмемо з налаштувань.',
    durationMinutes: '{minutes} хв',
    durationMinutesApprox: '~{minutes} хв',
    articleGeneratedTitle: 'Статтю збережено в Бібліотеку',
    articleGeneratedBody: 'Особиста стаття готова. Її завжди можна знайти у вкладці «Бібліотека».',
    articleGeneratedStart: 'Почати читання',
    articleGeneratedLibrary: 'До бібліотеки',
    levelBadge: 'Рівень {level}',
    minRead: '{minutes} хв читання',
  },
  recommendation: {
    whyArticle: 'Чому ця стаття?',
    dueWords: 'Слова до повторення',
  },
  learn: {
    stepOf: 'Крок {current} з {total}',
    readPrefix: 'Читай:',
    readThenFinish: 'Прочитай статтю й познач «Finished reading», щоб продовжити сесію.',
    nothingScheduled: 'На сьогодні нічого не заплановано',
    startRefresh: 'Почати повторення',
    startChallenge: 'Почати перевірку',
    backToToday: 'До «Сьогодні»',
  },
  practice: {
    generateStory: 'Створити історію',
    generateLesson: 'Створити урок',
    newLesson: 'Новий урок',
    storyDesc: 'Коротка історія на словах із твого словника',
    lessonDesc: 'Інтерактивний урок: розминка, практика й перевірка',
    selectToStart: 'Обери слова, щоб почати.',
    wordLimit: '{selected} / {max}',
    wordLimitHint: 'До {max} одиниць на історію або урок (залежить від рівня)',
    wordLimitReached: 'Максимум {max} — зніми одне, щоб додати інше',
    pickRandom: 'Взяти {count} випадкових',
    pickWords: 'Обери слова для практики',
    deselectAll: 'Зняти вибір',
    articleTipTitle: 'Потрібен текст, який залишиться?',
    articleTipBody:
      'Створи персональну статтю в Читанні — вона збережеться в бібліотеці, і можна тапати слова прямо в тексті.',
    articleTipCta: 'Перейти до Читання',
  },
  settingsChrome: {
    tabPreferences: 'Вподобання',
    tabAppearance: 'Оформлення',
    tabGoals: 'Цілі дня',
    tabNotifications: 'Сповіщення',
    tabFeedback: 'Зворотний звʼязок',
    tabSecurity: 'Безпека',
    tabAccount: 'Акаунт',
    preferencesTitle: 'Вподобання',
    preferencesDescription: 'Мова, рівень і налаштування навчання.',
    savePreferences: 'Зберегти',
    goalsTitle: 'Щоденні цілі',
    goalsDescription: 'Задай цілі слайдерами або точними числами.',
    goalsNewWords: 'Нових слів на день',
    goalsReviews: 'Повторень на день',
    goalsArticles: 'Статей на день',
    goalsPractice: 'AI-практик на день',
    goalsPracticeProHint:
      'AI-практика входить у Pro. Цілі збережуться і запрацюють після апгрейду.',
    goalsPracticeOff: 'Вимк',
    saveGoals: 'Зберегти цілі',
    notificationsTitle: 'Сповіщення',
    notificationsDescription: 'Email і нагадування.',
    notificationsComingSoon: 'Незабаром',
    notificationsComingSoonHint:
      'Щотижневий дайджест у розробці. Увімкнемо перемикач, коли буде готова доставка.',
    preferredTopics: 'Теми, які тобі подобаються',
    preferredTopicsHint: 'Використовуємо для рекомендацій статей',
    includeQuickChallenge: 'Коротка перевірка в щоденній сесії',
    includeQuickChallengeHint: 'Додає короткий словниковий чек у guided-сесію',
    defaultReviewMode: 'Режим повторення за замовчуванням',
    defaultReviewModeHint: 'Використовується при окремій сесії повторення',
    targetLevel: 'Цільовий рівень англійської',
    targetLevelHint: 'Статті й практика підлаштуються під цей рівень.',
    sessionLength: 'Довжина guided-сесії',
    sessionLengthLabel: 'Довжина guided-сесії: {minutes} хв',
    timezone: 'Часовий пояс',
    timezoneHint: 'Задано під час реєстрації. Денні ліміти AI скидаються опівночі UTC.',
    securitySignOutTitle: 'Вийти',
    securitySignOutHint: 'Вийти з Lexio на цьому пристрої.',
    changePasswordTitle: 'Змінити пароль',
    changePasswordDescription: 'Онови пароль для входу.',
    accountTitle: 'Акаунт',
    accountDescription: 'Керування даними акаунта.',
    backToSettings: 'До налаштувань',
    goBack: 'Назад',
    loadFailed: 'Не вдалося завантажити налаштування',
  },
}
